module.exports = __webpack_public_path__ + "static/menu-Martial Arts-3a8c5dfe721d37183589a15ac34c3443.png";